<div style="width: 350px; height: 250px;" data-cy="case-item-form-remove-cancel">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="case-item-form-remove-cancel-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="case-item-form-remove-cancel-header">
      <div class="section-header-title" data-cy="case-item-form-remove-cancel-title">
        Please confirm ...
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; text-align: center;" data-cy="case-item-form-remove-cancel-content">
      <ng-container *ngIf="formStarted">This form has already been started. Would you like to permanently delete this item or mark it as canceled?</ng-container>
      <ng-container *ngIf="!formStarted">Would you like to permanently delete this item or mark it as canceled?</ng-container>
      <div style="margin-top: 26px;" data-cy="case-item-form-remove-cancel-actions">
        <button (click)="markAsCanceled()" class="tdo-button" style="margin-right: 6px; background-color: var(--tdo-secondary); color: white;" data-cy="case-item-form-remove-cancel-canceled-btn">Canceled Item</button>
        <button (click)="delete()" *ngIf="canDelete" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="case-item-form-remove-cancel-delete-btn">Delete Item</button>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="case-item-form-remove-cancel-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="cancel()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="case-item-form-remove-cancel-close-btn">Close</button>
    </div>
  </div>
</div>

<!--<div class="confirm-dialog-container">
  <div class="message-header">
    <h5>Would you like to permanently delete this item or mark it as canceled?</h5>
  </div>

  <div class="action-container-upper">
    <button mat-raised-button color="warn" style="width: 120px;" class="action-button" [disabled]="!this.canDelete" (click)="delete()">Delete Item</button>
    <button mat-raised-button color="primary" style="width: 150px;" (click)="markAsCanceled()">Mark As Canceled</button>
  </div>

  <div class="action-container">
    <button mat-raised-button color="warn" style="width: 80px;" (click)="cancel()">Cancel</button>
  </div>
</div>-->
